import { publicRoutes } from "@/routes";

/**
 * Detects visitors arriving on /headhunter from a HH-connect email campaign.
 * When true, unauthenticated users should be redirected to login so they
 * land back on /headhunter with full context after signing in.
 *
 * Matching criteria (all must be true):
 *  - pathname is /headhunter
 *  - utm_medium  = "email"
 *  - utm_source  = "b2c_product"
 *  - utm_campaign starts with "hhconnect_"
 */
export function isHeadhunterEmailCampaign(pathname: string): boolean {
  if (pathname !== publicRoutes.headhunter) return false;

  const params = new URLSearchParams(window.location.search);
  const utmSource = params.get("utm_source");
  const utmCampaign = params.get("utm_campaign");

  // Costanza request from 23 april
  const isB2cFixedflowPremiumnetwork =
    utmSource === "b2c_fixedflow" && utmCampaign === "premiumnetwork";

  return (
    utmCampaign === "99match" ||
    isB2cFixedflowPremiumnetwork ||
    (utmCampaign?.startsWith("hhconnect_") ?? false)
  );
}
